<template>
  <IFrameResizer :config="config" />
</template>

<script>
import IFrameResizer from "../../components/IFrameResizer/IFrameResizer.vue";

export default {
  name: "app",
  components: {
    IFrameResizer
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config),
    };
  }
};
</script>
